<template>
  <TariffsTable
    :tariffImports="editableVehicle.tariffImports"
    :tariffId="editableVehicle.tariffId"
    :editableTariffImportOrigin="editableTariffImportOrigin"
    @cancel="isEditFormOpen=false"
    @addNewTariffImport="addNewTariffImport"
    @saveTariffImport="saveTariffImport"
    @saveTariffId="saveTariffId"
    @deleteTariffImport="deleteTariffImport">
  </TariffsTable>
</template>

<script>
import TariffsTable from "../../Shared/TariffsTable";
import { TariffImportOrigin } from "../../../models/TariffImportOrigin";
import _ from "lodash";

export default {
    components: { TariffsTable },
    props: {
        vehicle: {
            type: Object,
            default: function() {
                return null;
            }
        }
    },
    data() {
        return {
            editableVehicle: _.cloneDeep(this.vehicle),
            editableTariffImportOrigin: TariffImportOrigin.Vehicle,
            selectedTariffImport: null,
            isEditFormOpen: false
        };
    },
    watch: {
        vehicle(val) {
            this.editableVehicle = (!val) ? {} : _.cloneDeep(val);
        }
    },
    methods: {
        addNewTariffImport: function(tariffImport, eventTargetId) {
            this.$emit("addNewTariffImport", tariffImport, eventTargetId);
        },
        saveTariffImport: function(tariffImport, eventTargetId) {
            this.$emit("saveTariffImport", tariffImport, eventTargetId);
        },
        saveTariffId: function(tariffId, eventTargetId) {
            this.$emit("saveTariffId", tariffId, eventTargetId);
        },
        deleteTariffImport: function(tariffImport, eventTargetId) {
            this.$emit("deleteTariffImport", tariffImport, eventTargetId);
        }
    }
};
</script>
